import { extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import { messages as messageEn } from 'vee-validate/dist/locale/en.json';


extend('object', {
    validate(value, args) {
        if (typeof value !== 'object' || !value[args.key]) {
            return false;
        }

        return value[args.key] !== '';
    },
    params: ['key'],
    message: 'The {_field_} is required',
});

extend('required', {
    ...required,
    message: messageEn.required,
});

extend('numeric', {
    ...numeric,
    message: messageEn.numeric,
});

extend('lessthan', {
    params: ['max'],
    validate(value, { max }) {
        if(max) {
            return parseInt(value) < parseInt(max);
        } else {
            return true;
        }
    },
    message: 'Must be less than {max}',
});

extend('greaterthan', {
    params: ['min'],
    validate(value, { min }) {
        if(min) {
            return parseInt(value) > parseInt(min);
        } else {
            return true;
        }
    },
    message: 'Must be greater than {min}',
});
